import React from 'react';
import styled from "styled-components"
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BannerContainer } from "./style"
import Botao from "../../../components/Botao";




const BoxDiv = styled.div`


  // Adicione mais estilos conforme necessário
  width: 70%;
  color: white;
  max-width: 600;
  margin-top: 95px;
  height: 500px;
  //border: solid 2px red;

  @media (max-width: 768px) {
    width: 364px;
    margin-left: -20px;
    margin-top: -238px;
  color: white;
  max-width: 555;
  }

  @media (max-width: 375px) {
    width: 365px;
    margin-left: -9px;
    margin-top: -220px;
    font-size: 10px; 
  color: white;
  max-width: 555;
    
  }
`;

const BoxDivB = styled.div`


  // Adicione mais estilos conforme necessário
  width: 70%;
  align-items:center;
  margin-left: 40%;
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-left: 20%;
  margin-top: 20px;
  }

  @media (max-width: 375px) {
    margin-left: 20%;
  margin-top: 20px;
    
  }
`;



const Banner = () => {

  const abrirWhatsApp = () => {
    const url = "https://api.whatsapp.com/send?phone=5511983267276&text=&source=&data=";
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <BannerContainer>
      <BoxDiv>
        <Typography variant="h3" gutterBottom>
          Alves Assessoria
        </Typography>
        <Typography variant="h6" gutterBottom>
        Foi fundada em 2019, com sua trajetória construída em bases sólidas, a partir da relação de confiança com seus clientes.
        </Typography>
        <Typography variant="h6" gutterBottom>
        A atuação do escritório ocorre em todo o território nacional, representando pessoas físicas e jurídicas sempre pautado pela ética profissional.
        </Typography>
        <Typography variant="h6" gutterBottom>
        Com um estruturado corpo de advogados em constante atualização, o escritório presta assessoria jurídica, consultiva e contenciosa, nas mais diversas áreas do Direito.
        </Typography>
        <Typography variant="h6" gutterBottom>
        Somos reconhecidos pelo atendimento personalizado para as necessidades de cada cliente, trabalhando com excelência para oferecer o melhor atendimento.
        </Typography>
        <BoxDivB>
          <Botao
            texto='Seja Nosso Cliente'
            corFundo="#ff916e"
            corHover="#09af19"
            onClick={abrirWhatsApp}

          />
        </BoxDivB>
      </BoxDiv>



    </BannerContainer>
  );
};

export default Banner;